import { render, staticRenderFns } from "./AddItemToBasket.vue?vue&type=template&id=039f9320&scoped=true&"
import script from "./AddItemToBasket.vue?vue&type=script&lang=ts&"
export * from "./AddItemToBasket.vue?vue&type=script&lang=ts&"
import style0 from "./AddItemToBasket.vue?vue&type=style&index=0&id=039f9320&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039f9320",
  null
  
)

export default component.exports